module.exports = __webpack_public_path__ + "static/black2_v2-d03d1d519089964fa7c39c3c7725e943.png";